import { TLocalesKeys } from 'localization';

export enum ECategory {
  DEPOSIT = 'DEPOSIT',
  BONUS = 'BONUS',
  TARIFF = 'TARIFF',
  GOOD = 'GOOD',
  SERVICE = 'SERVICE',
  KASPI_PAY = 'KASPI_PAY',
  CLOUD_PAYMENTS = 'CLOUD_PAYMENTS',
  TINKOFF_SBP = 'TINKOFF_SBP',
  BEPAID_ERIP = 'BEPAID_ERIP',
  STRIPE = 'STRIPE',
}

export type TNormalizedItem = {
  title: string;
  category: ECategory;
  sold: number;
  sum: number;
  averagePrice: number;
  refundCount: number;
};

export interface IError {
  title?: TLocalesKeys;
  message: TLocalesKeys;
  field?: EDateField;
}
export enum EDateField {
  START,
  END,
}

export interface IExportSalesReportResponse {
  salesReport: {
    url: string;
  };
}
export interface IExportSalesSwitchReportResponse {
  exportSales: string;
}

export interface ISalesReportRequest {
  input: {
    from: string;
    to: string;
  };
}
export interface ISalesReportResponse {
  salesReport: {
    labels: Array<string>;
    extraLabels: Array<string>;
    keys: Array<string>;
    points: number;
    data: Array<{ values: Array<number> }>;
    summary: Array<{ title: string; value: number }>;
  };
}
